// extracted by mini-css-extract-plugin
module.exports = {"Alert":"ConfirmStart-module--Alert--3U1Up","Message":"ConfirmStart-module--Message--3Je88","Icon":"ConfirmStart-module--Icon--H228G"};